import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
};

export const LeaveSlice = createSlice({
  name: "LeaveReducer",
  initialState,
  reducers: {
    setLeaveList: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setLeaveList } = LeaveSlice.actions;

export default LeaveSlice.reducer;
